import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import GallerySection from '../components/GallerySection';
import { SERVICES } from '../data';

const ServicePage = () => {
  const { slug } = useParams();
  const service = SERVICES.find(s => s.slug === slug);

  if (!service) return <Navigate to="/" />;

  return (
    <Layout>
      <section className="relative pt-56 pb-24 flex items-center justify-center bg-slate-900">
        <div className="absolute inset-0">
          <img 
            src={service.image} 
            alt={service.title} 
            className="w-full h-full object-cover opacity-50"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent" />
        </div>
        <div className="relative z-10 text-center">
          <h1 
            className="text-[2rem] md:text-7xl font-bold text-white tracking-tighter mb-4"
          >
            {service.title.toUpperCase()}
          </h1>
          <div className="w-20 h-1 bg-amber-500 mx-auto"></div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-20">
            <div className="lg:col-span-2">
              {service.content ? (
                <div className="mb-10">
                  <div className="space-y-10 text-slate-600 text-lg font-light leading-relaxed">
                    {service.content.map((section, idx) => (
                      <div key={idx}>
                        <h2 className="text-2xl font-bold text-slate-900 mb-4 uppercase tracking-tight">
                          {section.heading}
                        </h2>
                        <div className="space-y-4">
                          {section.text.map((p, pIdx) => (
                            <p key={pIdx}>{p}</p>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <>
                  <h2 className="text-3xl font-bold text-slate-900 mb-6 uppercase tracking-tight">
                    PROFESSIONEL LØSNING INDENFOR <br />
                    <span className="text-amber-500">{service.title}</span>
                  </h2>
                  <div className="space-y-6 text-slate-600 text-lg font-light leading-relaxed mb-10">
                    <p>{service.description}</p>
                    <p>
                      Vi har mange års erfaring med netop {service.title.toLowerCase()}, og vi ved hvad der kræves for at opnå et resultat, der både er æstetisk flot og teknisk holdbart. Vi bruger kun de bedste materialer og sørger altid for en grundig oprydning, når vi er færdige.
                    </p>
                  </div>
                </>
              )}
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
                {[
                  "Kvalitetssikring",
                  "Konkurrencedygtige priser",
                  "Erfarne tømrere",
                  "Oprydning inkluderet",
                  "Byg Garanti",
                  "Lokalt kendskab"
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 text-slate-800 font-medium bg-slate-50 p-4 border-l-2 border-amber-500">
                    <CheckCircle2 className="text-amber-500 shrink-0" size={18} />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-slate-900 p-10 text-white shadow-xl sticky top-32">
                <h4 className="text-xl font-bold mb-4 uppercase tracking-tight">Skal vi tage et kig?</h4>
                <p className="text-slate-400 mb-8 font-light">
                  Vi kommer gerne forbi og giver et uforpligtende estimat på din opgave. Vi rådgiver også gerne om materialevalg og design.
                </p>
                <Link 
                  to="/kontakt" 
                  className="inline-flex items-center text-amber-500 font-bold hover:text-white transition-colors group"
                >
                  KONTAKT OS NU <ArrowRight size={18} className="ml-2 group-hover:translate-x-2 transition-transform" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {service.gallery && service.gallery.length > 0 && (
        <GallerySection images={service.gallery} title={`Galleri - ${service.title}`} />
      )}
    </Layout>
  );
};

export default ServicePage;
